import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import tippy from 'tippy.js';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-information-icon',
  templateUrl: './information-icon.component.html',
  styleUrls: ['./information-icon.component.scss']
})
export class InformationIconComponent implements AfterViewInit, OnDestroy {
  @Input() information: string;
  @Input() description: string;
  @Input() tippyProps: any = {};
  @Input() tooltipCssClass: string = '';

  content: string = '';

  private mergeDescription = false;
  private contentSeparator = '<br><br>';

  get tooltipSelector(): string {
    return this.tooltipCssClass ? `.${this.tooltipCssClass}` : '.information-tooltip';
  }

  constructor() {
  }

  public ngAfterViewInit(): void {
    this.initTooltipContent();

    setTimeout(() => {
      tippy(this.tooltipSelector, {
        duration: 250,
        arrow: true,
        arrowType: 'round',
        ...this.tippyProps,
        theme: this.tippyProps.theme ? `${this.tippyProps.theme} information` : 'information',
      });
    }, 0)
  }

  public ngOnDestroy(): void {
    const tooltipLayer = document.querySelector('.information-theme');
    if (tooltipLayer) {
      tooltipLayer.parentElement.remove();
    }
  }

  private initTooltipContent(): void {
    this.content = this.information;

    if (this.mergeDescription && isNotNullOrUndefined(this.description)) {
      this.content += `${this.contentSeparator}${this.description}`;
    }
  }
}
